import { render, staticRenderFns } from "./thicknesses.vue?vue&type=template&id=46e0989e&"
import script from "./thicknesses.vue?vue&type=script&lang=js&"
export * from "./thicknesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports